import React from 'react';
import {
  arrayOf, bool, shape, string, node
} from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/grid';
import { BulletList } from '../BulletList/BulletList';
import { InfoGuides } from '../InfoGuides/InfoGuides';
import { ProductInfo } from './ProductInfo';
import './mobile-content.scss';

export const MobileContent = (props) => {
  const {
    description,
    documents,
    highlights,
    itemId,
    modelNumber,
    storeSkuNumber,
    bullets,
    showRichContentsOnly,
    hideRichContents,
    channel,
    upc,
    showUpcCode
  } = props;

  return (
    <Col className="mobile-content-wrapper">
      <Row>{highlights}</Row>
      {(modelNumber || storeSkuNumber || itemId) && (
        <Row className="card-mobile-row">
          { modelNumber && <ProductInfo title="Model" info={modelNumber} /> }
          { storeSkuNumber && <ProductInfo title="Sku" info={storeSkuNumber} /> }
          { itemId && <ProductInfo title="Internet" info={itemId} /> }
          { showUpcCode && upc && <ProductInfo title="UPC" info={upc} /> }
        </Row>
      )}
      <Row className="main-description card-mobile-row">
        <p className="main-description--mobile">{description}</p>
        <BulletList
          bullets={bullets}
          margin
          isMobile
          showRichContentsOnly={showRichContentsOnly}
          hideRichContents={hideRichContents}
        />
        { documents && <InfoGuides documents={documents} channel={channel} />}
      </Row>
    </Col>
  );
};

MobileContent.displayName = 'MobileContent';

MobileContent.propTypes = {
  channel: string.isRequired,
  description: string.isRequired,
  documents: arrayOf(shape({
    name: string.isRequired,
    url: string.isRequired
  })).isRequired,
  highlights: node.isRequired,
  hideRichContents: bool,
  itemId: string.isRequired,
  modelNumber: string,
  bullets: arrayOf(shape({})).isRequired,
  showRichContentsOnly: bool,
  storeSkuNumber: string,
  upc: string,
  showUpcCode: bool
};

MobileContent.defaultProps = {
  hideRichContents: false,
  modelNumber: '',
  showRichContentsOnly: false,
  storeSkuNumber: '',
  upc: '',
  showUpcCode: false
};
